import React from "react";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

export default function POViewPage() {
  const { state } = useLocation();
  const data = state || {};

  const total =
    data.items?.reduce((sum, item) => sum + item.rate * item.qty, 0) || 0;

  return (
    <div className="container mt-4">

      {/* PAGE TITLE */}
      <h2 style={{ fontWeight: "600", marginBottom: "25px" }}>
        Purchase Order
      </h2>

      {/* ROW 1 */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label className="fw-semibold mb-1">PO Id *</label>
          <input
            className="form-control"
            value={data.poId || ""}
            readOnly
          />
        </div>

        <div className="col-md-6">
          <label className="fw-semibold mb-1">Project</label>
          <input
            className="form-control"
            value={data.projectName || ""}
            readOnly
          />
        </div>
      </div>

      {/* ROW 2 */}
      <div className="row mb-3">
        <div className="col-md-15">
          <label className="fw-semibold mb-1">Title *</label>
          <input
            className="form-control"
            value={data.title || ""}
            readOnly
          />
        </div>

      </div>

      {/* ROW 3 */}
      <div className="row mb-4">
        <div className="col-md-6">
          <label className="fw-semibold mb-1">Vendor</label>
          <input
            className="form-control"
            value={data.vendor || ""}
            readOnly
          />
        </div>

        <div className="col-md-6">
          <label className="fw-semibold mb-1">Send Approve</label>
          <input
            className="form-control"
            value={data.approver || ""}
            readOnly
          />
        </div>
      </div>

      {/* TABLE */}
      <div className="table-responsive">
        <table className="table table-bordered text-center">

          {/* HEADER */}
          <thead style={{ background: "#e6e6e6" }}>
            <tr>
              <th style={{ width: "80px" }}>S. No</th>
              <th>Item Name</th>
              <th style={{ width: "120px" }}>Unit</th>
              <th style={{ width: "120px" }}>Rate ₹</th>
              <th style={{ width: "120px" }}>Quantity</th>
              <th style={{ width: "140px" }}>Total</th>
            </tr>
          </thead>

          {/* BODY */}
          <tbody>
            {data.items?.map((item, index) => {
              const itemTotal = item.rate * item.qty;

              return (
                <tr key={index}>
                  <td>{String(index + 1).padStart(2, "0")}</td>

                  <td>{item.name}</td>

                  <td>{item.unit}</td>

                  <td>{item.rate}</td>

                  <td>{item.qty}</td>

                  <td>{itemTotal.toLocaleString()}</td>
                </tr>
              );
            })}
          </tbody>

          {/* FOOTER TOTAL */}
         <tfoot>
  <tr>
    <td
      colSpan="6"
      style={{
        background: "#ff6f00",
        color: "#ffffff",
        fontWeight: "600",
        padding: "10px 15px"
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          color: "#ffffff"
        }}
      >
        <span style={{ color: "#ffffff" }}>Total</span>

        <span style={{ color: "#ffffff" }}>
          {total.toLocaleString()}
        </span>
      </div>
    </td>
  </tr>
</tfoot>

        </table>
      </div>

    </div>
  );
}